import { render } from "./IconExpandLess.vue?vue&type=template&id=7e5ced40"
import script from "./IconExpandLess.vue?vue&type=script&lang=js"
export * from "./IconExpandLess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__